const NotFound = (props) => {
  return (
    <div className="border !border-red-800 !bg-red-300 !text-red-800 !p-4 rounded">
      App "{props.app}" not found
    </div>
  );
};

export default NotFound;
